import { Entry } from '../Entry'

export function Entry20240103() {
  return (
    <Entry title="Jan 03 2024 - v3.5.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15644/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
